export default __webpack_public_path__ + "static/media/No.0-0.532c040e.jpg";